// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"19":"empty-homepage","132":"widget-simple-detail","204":"provider","270":"cdp-page","351":"widget-setup","524":"app","884":"admin","903":"admin-webhooks"}[chunkId] + ".css";
};